(function () {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.helpers = Dashboard.helpers || {};

    const pageItemCounts = [ 10, 25, 50, 100, 250, 500, 1000, 2500 ];

    window.Dashboard.helpers.tableHelper = {
        pageItemCounts: pageItemCounts,
        sortAndFilter: function (params, filter, items) {
            const sortedItems = params.sorting()
                ? filter('orderBy')(items, params.orderBy())
                : items;

            const count = params.count();
            const page = params.page();
            return sortedItems.slice(
                (page - 1) * count,
                page * count
            );
        },
        reloadTable: function (
            tableParams,
            tableItems,
            noPagination) {
            this.useCount(
                tableParams,
                noPagination ? 0 : tableItems.length);
            tableParams.reload();
        },
        useCount: function (
            tableParams,
            totalCount) {
            const index = pageItemCounts.findIndex((count) => count > totalCount);
            tableParams.settings({ counts: (index > 0) ? pageItemCounts.slice(0, index + 1) : [] });
            tableParams.total(totalCount)
        }
    };
})();
